import type { Article } from './types';

export const articles: Article[] = [
  {
    slug: 'dingji-liuliang-luyin-fengbo',
    title: '某顶流歌手录音风波始末：三段音频与两次改口',
    category: 'ent',
    categoryName: '娱乐圈',
    excerpt:
      '从深夜爆料帖到工作室声明，围绕一段录音的争论在 72 小时内出现三次方向变化。我们把公开可见的音频、声明与被删除的动态按时间顺序整理成可核对的档案。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20dim%20recording%20studio%20room%20with%20a%20single%20microphone%20and%20soft%20crimson%20practical%20light%2C%20moody%20editorial%20photography%2C%20deep%20shadows%2C%20muted%20amber%20highlights%2C%20cinematic%20and%20clean%20composition&width=800&height=600&seq=guatian-cover-ent01&orientation=landscape',
    author: '档案组 · 阿岩',
    date: '2026-09-08',
    readTime: '9 分钟',
    heat: '98.6万',
    status: '持续发酵',
    tags: ['录音证据', '工作室声明', '时间线整理'],
    materials: [
      { type: '音频', label: '第一版录音（28 秒剪辑）', note: '最早由匿名账号发布，存在明显剪接点', status: '存疑' },
      { type: '音频', label: '第二版完整音频（3 分 42 秒）', note: '由第三方账号补发，含未剪辑段落', status: '已归档' },
      { type: '文本', label: '工作室首份声明', note: '发布于事件次日凌晨', status: '已归档' },
      { type: '文本', label: '被删除的粉丝长文截图', note: '转发量超过 4 万后消失', status: '待核实' },
    ],
    timeline: [
      { date: '09-05 23:40', title: '匿名帖首发', desc: '某小号发布 28 秒音频片段，配文仅一句「自己听」。', tag: '源头' },
      { date: '09-06 02:10', title: '话题登上热搜', desc: '片段被搬运至多个平台，出现第一轮解读。', tag: '发酵' },
      { date: '09-06 11:30', title: '工作室首次回应', desc: '称音频「经剪辑拼接，与事实不符」，未逐段说明。', tag: '回应' },
      { date: '09-07 16:05', title: '完整音频出现', desc: '第三方账号补发 3 分 42 秒版本，与首版内容顺序不一致。', tag: '反转' },
      { date: '09-08 09:00', title: '粉丝长文被删', desc: '一篇梳理时间点的长文在转发破 4 万后消失。', tag: '存疑' },
    ],
    related: ['lianxishi-jieyue-fengbo', 'yiren-xiaohao-yiyun', 'wangkong-lianai-shijianxian'],
  },
  {
    slug: 'zhibo-daihuo-shuju-yiyun',
    title: '直播带货数据疑云：刷单截图与后台曲线对不上',
    category: 'influencer',
    categoryName: '网红圈',
    excerpt:
      '一场号称「单场破亿」的直播，被前员工晒出两张后台截图质疑数据注水。截图里的下单曲线与公开战报出现了肉眼可见的缺口，我们把双方口径并排放在一起。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20setup%20with%20ring%20light%20and%20ringing%20phones%20on%20a%20desk%2C%20warm%20amber%20studio%20lighting%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20clean%20warm%20neutral%20background&width=800&height=600&seq=guatian-cover-inf02&orientation=landscape',
    author: '档案组 · 老周',
    date: '2026-09-07',
    readTime: '7 分钟',
    heat: '76.2万',
    status: '待回应',
    tags: ['数据注水', '后台截图', '带货战报'],
    materials: [
      { type: '截图', label: '后台订单曲线截图（两张）', note: '含下单时间分布，发布者称来自官方后台', status: '存疑' },
      { type: '文本', label: '官方战报海报', note: '标注「单场 GMV 破亿」', status: '已归档' },
      { type: '音频', label: '前员工口述录音', note: '时长 6 分钟，提到「回流单」操作', status: '待核实' },
    ],
    timeline: [
      { date: '09-04 20:00', title: '战报发布', desc: '直播结束后官方发布破亿战报海报。', tag: '源头' },
      { date: '09-06 14:20', title: '前员工爆料', desc: '晒出两张后台截图，称存在集中退款与回流单。', tag: '发酵' },
      { date: '09-07 10:00', title: '机构回应', desc: '称截图「非后台原始数据」，但未提供原始流水。', tag: '回应' },
    ],
    related: ['qiye-gaoguan-qunliao-waixie', 'shangye-jingzheng-ppt', 'wangkong-lianai-shijianxian'],
  },
  {
    slug: 'qiye-gaoguan-qunliao-waixie',
    title: '某企业高管内部群聊外泄：截图来源成谜',
    category: 'business',
    categoryName: '商界',
    excerpt:
      '一段据称来自某公司高管内部群的聊天截图在行业社群流传，内容涉及人事调整。截图里出现了三处字体、头像与时间戳的不一致，让「真假」成了比内容更大的话题。',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20modern%20office%20meeting%20room%20at%20night%20with%20a%20glowing%20laptop%20screen%20and%20documents%2C%20warm%20amber%20accent%20light%2C%20moody%20editorial%20photography%2C%20muted%20neutral%20tones%2C%20sharp%20detail&width=800&height=600&seq=guatian-cover-biz03&orientation=landscape',
    author: '档案组 · 沈工',
    date: '2026-09-06',
    readTime: '8 分钟',
    heat: '61.4万',
    status: '待回应',
    tags: ['群聊截图', '人事调整', '图像鉴定'],
    materials: [
      { type: '截图', label: '内部群聊天记录（9 张）', note: '第 3、6 张存在字体与头像圆角不一致', status: '存疑' },
      { type: '文本', label: '公司对外公告', note: '未直接回应该截图，仅说明人事安排', status: '已归档' },
      { type: '分析', label: '第三方图像比对笔记', note: '指出两处元数据缺失', status: '待核实' },
    ],
    timeline: [
      { date: '09-02 21:15', title: '截图流出', desc: '行业社群开始流传 9 张聊天记录。', tag: '源头' },
      { date: '09-03 12:00', title: '公司公告', desc: '发布人事安排公告，未提及截图真伪。', tag: '回应' },
      { date: '09-05 18:40', title: '图像分析出现', desc: '有技术博主指出字体与头像像素异常。', tag: '存疑' },
    ],
    related: ['shangye-jingzheng-ppt', 'zhibo-daihuo-shuju-yiyun', 'hangye-shuijun-taolu'],
  },
  {
    slug: 'dianjing-xuanshou-daidap',
    title: '电竞选手代打疑云：训练赛录像里的异常操作',
    category: 'esports',
    categoryName: '电竞圈',
    excerpt:
      '一场关键的晋级赛之后，有人翻出选手此前的几场训练赛录像，指出鼠标移动轨迹与惯用手习惯不符。俱乐部随即公布了原始录像与设备日志。',
    cover: 'https://readdy.ai/api/search-image?query=Esports%20gaming%20station%20with%20mechanical%20keyboard%20and%20glowing%20amber%20monitor%20in%20a%20dark%20arena%20booth%2C%20cinematic%20editorial%20photography%2C%20warm%20highlights%2C%20muted%20charcoal%20tones&width=800&height=600&seq=guatian-cover-esp04&orientation=landscape',
    author: '档案组 · 小满',
    date: '2026-09-05',
    readTime: '6 分钟',
    heat: '52.8万',
    status: '已反转',
    tags: ['训练赛录像', '设备日志', '操作习惯'],
    materials: [
      { type: '视频', label: '训练赛录像（第 2、4 局）', note: '网友标记出 3 处操作异常', status: '存疑' },
      { type: '日志', label: '设备输入日志', note: '俱乐部提供，显示同一外设 ID', status: '已归档' },
      { type: '文本', label: '联盟核查说明', note: '认定无代打行为', status: '已归档' },
    ],
    timeline: [
      { date: '08-30 22:30', title: '帖子出现', desc: '网友发帖对比操作轨迹，质疑代打。', tag: '源头' },
      { date: '09-01 15:00', title: '俱乐部回应', desc: '公布训练赛原始录像与设备日志。', tag: '回应' },
      { date: '09-05 11:00', title: '联盟核查结果', desc: '认定不存在代打，事件反转。', tag: '反转' },
    ],
    related: ['lianxishi-jieyue-fengbo', 'tiyu-mingxing-xingcheng', 'hangye-shuijun-taolu'],
  },
  {
    slug: 'lianxishi-jieyue-fengbo',
    title: '练习生解约风波：合约条款与聊天记录的双重版本',
    category: 'ent',
    categoryName: '娱乐圈',
    excerpt:
      '一位练习生宣布解约，双方各自放出聊天记录截图。两份截图在「通知时间」与「排练安排」两处出现矛盾，把争议从合约条款推到了聊天记录的真伪上。',
    cover: 'https://readdy.ai/api/search-image?query=Empty%20rehearsal%20room%20with%20mirrored%20wall%20and%20wooden%20floor%2C%20single%20spotlight%2C%20warm%20amber%20glow%2C%20quiet%20melancholic%20editorial%20photography%2C%20muted%20neutral%20palette&width=800&height=600&seq=guatian-cover-ent05&orientation=landscape',
    author: '档案组 · 阿岩',
    date: '2026-09-03',
    readTime: '8 分钟',
    heat: '44.1万',
    status: '持续发酵',
    tags: ['解约纠纷', '聊天记录', '合约条款'],
    materials: [
      { type: '截图', label: '练习生方聊天记录（5 张）', note: '含排练通知时间', status: '已归档' },
      { type: '截图', label: '公司方聊天记录（7 张）', note: '同一时段的对话顺序不同', status: '存疑' },
      { type: '文本', label: '合约关键条款节选', note: '解约赔偿部分被打了码', status: '待核实' },
    ],
    timeline: [
      { date: '08-28 19:00', title: '解约声明', desc: '练习生方发布长文宣布解约。', tag: '源头' },
      { date: '08-29 14:30', title: '公司回应', desc: '公布另一版聊天记录，指对方截取片段。', tag: '回应' },
      { date: '09-03 10:20', title: '双方再次发声', desc: '就「通知时间」各执一词，未达成一致。', tag: '发酵' },
    ],
    related: ['dingji-liuliang-luyin-fengbo', 'yiren-xiaohao-yiyun', 'dianjing-xuanshou-daidap'],
  },
  {
    slug: 'tiyu-mingxing-xingcheng',
    title: '体育明星私生活传闻：一张行程表引发的连锁反应',
    category: 'sports',
    categoryName: '体育圈',
    excerpt:
      '一张被指为选手私人行程的表格在粉丝群流传，随后出现多个「偶遇」版本。我们对比了公开赛程与表格内容，发现其中三天与官方行程直接冲突。',
    cover: 'https://readdy.ai/api/search-image?query=Quiet%20empty%20stadium%20corridor%20with%20afternoon%20sunlight%20through%20concrete%20columns%2C%20warm%20dusty%20amber%20tone%2C%20editorial%20architectural%20photography%2C%20muted%20neutral%20palette&width=800&height=600&seq=guatian-cover-spt06&orientation=landscape',
    author: '档案组 · 沈工',
    date: '2026-09-01',
    readTime: '5 分钟',
    heat: '37.9万',
    status: '待回应',
    tags: ['行程表', '赛程核对', '粉丝爆料'],
    materials: [
      { type: '表格', label: '行程表照片', note: '无来源标注，含疑似航班信息', status: '存疑' },
      { type: '文本', label: '官方赛程公示', note: '与表格中三天直接冲突', status: '已归档' },
    ],
    timeline: [
      { date: '08-27 21:00', title: '表格流出', desc: '粉丝群流传一张行程表照片。', tag: '源头' },
      { date: '08-28 12:00', title: '对比帖出现', desc: '网友列出与官方赛程的冲突点。', tag: '存疑' },
      { date: '09-01 09:30', title: '暂无正式回应', desc: '团队未就该表格作出说明。', tag: '待回应' },
    ],
    related: ['dianjing-xuanshou-daidap', 'wangkong-lianai-shijianxian', 'yiren-xiaohao-yiyun'],
  },
  {
    slug: 'wangkong-lianai-shijianxian',
    title: '网红恋爱时间线：合照、删除与取关的顺序学',
    category: 'influencer',
    categoryName: '网红圈',
    excerpt:
      '两位博主的互动被粉丝逐帧拆解，从同款背景到取关顺序，拼出一条被反复修改的时间线。我们把可公开验证的节点单独拎出来，去掉推测部分。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20cafe%20table%20with%20two%20coffee%20cups%20and%20a%20phone%2C%20soft%20amber%20afternoon%20light%2C%20cozy%20editorial%20photography%2C%20muted%20cream%20and%20terracotta%20tones&width=800&height=600&seq=guatian-cover-inf07&orientation=landscape',
    author: '档案组 · 小满',
    date: '2026-08-30',
    readTime: '6 分钟',
    heat: '33.5万',
    status: '已归档',
    tags: ['同款背景', '取关顺序', '时间线'],
    materials: [
      { type: '图片', label: '同款背景对比图（4 组）', note: '背景元素可对应但非同一时段', status: '存疑' },
      { type: '记录', label: '公开取关时间截图', note: '双方先后顺序可查', status: '已归档' },
      { type: '文本', label: '粉丝时间线整理帖', note: '含大量推测段落', status: '待核实' },
    ],
    timeline: [
      { date: '08-20 20:30', title: '同款背景被扒', desc: '粉丝发现两张照片背景元素相似。', tag: '源头' },
      { date: '08-22 23:00', title: '一方取关', desc: '公开关注列表出现变化。', tag: '发酵' },
      { date: '08-30 15:00', title: '双方均未回应', desc: '内容停留在公开互动层面，事件归档。', tag: '归档' },
    ],
    related: ['tiyu-mingxing-xingcheng', 'yiren-xiaohao-yiyun', 'hangye-shuijun-taolu'],
  },
  {
    slug: 'shangye-jingzheng-ppt',
    title: '商业竞争疑云：一份被指「定向爆料」的PPT',
    category: 'business',
    categoryName: '商界',
    excerpt:
      '一份排版精良的 PPT 在投资人群里疯传，内容直指某公司的数据造假。但它出现的时间点、页脚编号与投放对象，让很多人怀疑这是一次有组织的定向爆料。',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20printed%20presentation%20slides%20on%20a%20dark%20wooden%20desk%20with%20warm%20desk%20lamp%20light%2C%20moody%20editorial%20photography%2C%20amber%20highlights%2C%20muted%20neutral%20tones&width=800&height=600&seq=guatian-cover-biz08&orientation=landscape',
    author: '档案组 · 老周',
    date: '2026-08-29',
    readTime: '7 分钟',
    heat: '31.2万',
    status: '待回应',
    tags: ['PPT 爆料', '定向传播', '数据造假质疑'],
    materials: [
      { type: '文件', label: '爆料 PPT（38 页）', note: '页脚编号存在跳号', status: '存疑' },
      { type: '文本', label: '被指公司回应摘要', note: '称「内容失实」，附一份数据说明', status: '已归档' },
    ],
    timeline: [
      { date: '08-25 22:00', title: 'PPT 流传', desc: '在多个投资人社群同时出现。', tag: '源头' },
      { date: '08-26 16:00', title: '公司回应', desc: '发布数据说明，逐条否认。', tag: '回应' },
      { date: '08-29 10:00', title: '传播路径被扒', desc: '发现首发的三个账号注册时间接近。', tag: '存疑' },
    ],
    related: ['qiye-gaoguan-qunliao-waixie', 'hangye-shuijun-taolu', 'zhibo-daihuo-shuju-yiyun'],
  },
  {
    slug: 'yiren-xiaohao-yiyun',
    title: '艺人小号疑云：点赞记录与IP归属地的推理',
    category: 'ent',
    categoryName: '娱乐圈',
    excerpt:
      '一个长期点赞负面话题的账号被指是某艺人的小号。网友们用头像残留、点赞节奏与 IP 归属地拼出「证据链」，但其中最关键的一环始终没有公开来源。',
    cover: 'https://readdy.ai/api/search-image?query=Single%20smartphone%20glowing%20on%20a%20dark%20table%20at%20night%20with%20bokeh%20city%20lights%20behind%2C%20warm%20amber%20reflections%2C%20moody%20editorial%20photography%2C%20muted%20charcoal%20tones&width=800&height=600&seq=guatian-cover-ent09&orientation=landscape',
    author: '档案组 · 阿岩',
    date: '2026-08-27',
    readTime: '6 分钟',
    heat: '28.4万',
    status: '待回应',
    tags: ['小号', 'IP 归属地', '点赞记录'],
    materials: [
      { type: '记录', label: '账号点赞时间分布图', note: '与艺人公开行程存在重合', status: '存疑' },
      { type: '截图', label: '头像缓存残留截图', note: '清晰度不足，无法确认', status: '待核实' },
      { type: '文本', label: '工作室回应', note: '否认与该账号存在关联', status: '已归档' },
    ],
    timeline: [
      { date: '08-24 20:00', title: '推理帖出现', desc: '网友发帖列出四条「证据」。', tag: '源头' },
      { date: '08-26 11:00', title: '工作室回应', desc: '否认账号关联。', tag: '回应' },
      { date: '08-27 09:00', title: '关键证据缺失', desc: '最关键的一条推理始终无公开来源，标注存疑。', tag: '存疑' },
    ],
    related: ['dingji-liuliang-luyin-fengbo', 'lianxishi-jieyue-fengbo', 'wangkong-lianai-shijianxian'],
  },
  {
    slug: 'hangye-shuijun-taolu',
    title: '爆料生态观察：从「首发号」到「营销号矩阵」的套路拆解',
    category: 'industry',
    categoryName: '行业观察',
    excerpt:
      '为什么同一个瓜会在十几个账号上同时出现?我们复盘了三次典型传播事件，总结出「首发号—搬运号—解读号」的三段式套路，帮你识别哪些是信息、哪些是带节奏。',
    cover: 'https://readdy.ai/api/search-image?query=Wall%20of%20glowing%20phone%20screens%20showing%20identical%20content%20grids%20in%20a%20dark%20room%2C%20warm%20amber%20glow%2C%20conceptual%20editorial%20photography%2C%20muted%20charcoal%20and%20gold%20tones&width=800&height=600&seq=guatian-cover-ind10&orientation=landscape',
    author: '档案组 · 沈工',
    date: '2026-08-24',
    readTime: '10 分钟',
    heat: '22.7万',
    status: '已归档',
    tags: ['传播路径', '营销号', '信息溯源'],
    materials: [
      { type: '图表', label: '三次事件的传播节点图', note: '按发布时间还原扩散顺序', status: '已归档' },
      { type: '文本', label: '账号注册信息对比', note: '仅使用平台公开可见字段', status: '已归档' },
    ],
    timeline: [
      { date: '08-18 21:00', title: '锁定首发账号', desc: '梳理三次事件的最早发布者。', tag: '溯源' },
      { date: '08-21 15:00', title: '比对搬运规律', desc: '发现固定时间差与统一话术。', tag: '分析' },
      { date: '08-24 10:00', title: '整理成方法论', desc: '输出可复用的识别清单。', tag: '归档' },
    ],
    related: ['qiye-gaoguan-qunliao-waixie', 'shangye-jingzheng-ppt', 'dianjing-xuanshou-daidap'],
  },
];

export const getArticleBySlug = (slug: string): Article | undefined =>
  articles.find((item) => item.slug === slug);